import axios from "@/axios";
import { CategoryPostDto } from "@/types";

export function CategoryListPut(
  platform: number | string,
  categories: Array<CategoryPostDto>
) {
  return axios.put(`/categories/${platform}`, { categories });
}
